import { connect } from 'react-redux';
import { fetchingConfiguration, filterCalendar } from '../../redux/reservations/actions';
import Configuration from './Configuration';
import { getAppointmentTypes } from '../../redux/appointmentTypes/actions';

const mapDispatchToProps = {
  filterCalendar,
  getAppointmentTypes,
  fetchingConfiguration
};

const mapStateToProps = (state) => ({
  configurationDate: state.reservationReducer.configurationDate,
  appointmentTypes: state.appointmentTypesReducer.appointmentTypes,
});


export default connect(mapStateToProps, mapDispatchToProps)(Configuration);
